import { __ } from "@wordpress/i18n";
import React, { useState } from 'react';
import Hint from '../components/Hint/Hint';
import Switch from '../components/Switch/Switch';
import { useMenu } from '../contexts/MenuContext';
import withForm from '../layouts/withForm';
const SecurityAPIPrivacy = ({handleChange}) => {
    const {
        settingData
    } = useMenu();
    const [selectedFilter, setSelectedFilter] = useState("all");
        const filters = [
            { all: "All" },
            { basic: "Basic" },
            { wordpress: "WordPress Specific" },
            { "script-styles": "Script & Styles" },
            { "rss-feed": "RSS Feed Settings" },
        ];
    return (
        <>
            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Enable API Privacy", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Enable privacy for API requests.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable API Privacy", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.api_privacy.enable"
                                    checked={settingData?.security?.api_privacy.enable} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                    valueType="string"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("User-Agent URL", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("No Hint", "ultimate-security")}/>
                                    <select 
                                        className="form-select"
                                        value={settingData?.security?.api_privacy.user_agent_behaviour} 
                                        onChange={(e) => handleChange('security.api_privacy.user_agent_behaviour', e.target.value)}
                                    >
                                        <option value="none">{__("No changes", "ultimate-security")}</option>
                                        <option value="strip_wp">{__("Strip site URL from all WP API requests", "ultimate-security")}</option>
                                        <option value="strip_all">{__("Strip site URL from all requests", "ultimate-security")}</option>
                                        <option value="modify_wp">{__("Replace URL with a unique hash for all WP API requests", "ultimate-security")}</option>
                                        <option value="modify_all">{__("Replace URL with a unique hash for all requests", "ultimate-security")}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Options", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Fine-tune your API privacy settings with advanced options to strip unnecessary information, limit external exposure, and enhance security.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Strip WordPress version information from User-Agent", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.api_privacy.strip_wp_version"
                                    checked={settingData?.security?.api_privacy.strip_wp_version} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                    valueType="string"
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Strip external plugins from API calls", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.api_privacy.strip_plugins"
                                    checked={settingData?.security?.api_privacy.strip_plugins} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                    valueType="string"
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Strip external themes from API calls", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.api_privacy.strip_themes"
                                    checked={settingData?.security?.api_privacy.strip_themes} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                    valueType="string"
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Modify data sent to core update API", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.api_privacy.strip_core_data"
                                    checked={settingData?.security?.api_privacy.strip_core_data} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                    valueType="string"
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Strip wp_blog and wp_install headers", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.api_privacy.strip_core_headers"
                                    checked={settingData?.security?.api_privacy.strip_core_headers} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                    valueType="string"
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Strip user login info from JSON API", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.api_privacy.strip_user_logins"
                                    checked={settingData?.security?.api_privacy.strip_user_logins} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                    valueType="string"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Debug", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Use debugging tools to test API interactions and resolve issues efficiently. Recommended for advanced users during testing only.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Disable HTTPs for packet sniffing (should only be used for testing)", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.api_privacy.disable_https"
                                    checked={settingData?.security?.api_privacy.disable_https} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                    valueType="string"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(SecurityAPIPrivacy, 'security.api_privacy');